module.exports = __webpack_public_path__ + "img/Home-Pahe--Corporate.43ecf9f6.jpg";